const buy = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><circle cx="8" cy="8" r="7.25" stroke-width="1.5"/><path stroke-width="0" d="M7.25 7H4.5L8 3.5 11.5 7H8.75v4.7h-1.5z"/></svg>',
};

export { buy as default };
